import { motion } from 'framer-motion';

import TeamMemberItem, { type TeamMember } from './TeamMemberItem';

const TeamSection = () => {
  const teamMembers: TeamMember[] = [
    {
      id: 1,
      name: 'Mo Lidsky',
      role: 'Founder',
      bio: 'Mo Lidsky is the thought leader behind konnect better, where he brings big ideas to life with vision, strategy, and a whole lot of heart. As a father, husband, entrepreneur, and a trusted confidante to some of the most affluent families in North America, Mo has seen firsthand that true fulfilment doesn’t just come from wealth but from meaningful relationships. Driven by his passion for helping people connect in more impactful ways, Mo is on a mission to turn wealth into wellbeing, one authentic relationship at a time.',
      image: '/images/mo_lidsky.png',
      social: {
        linkedin: 'https://www.linkedin.com/in/molidsky/',
      },
    },
    {
      id: 2,
      name: 'Bob Gould',
      role: 'Co-Founder and Special Advisor',
      bio: 'Bob Gould is the co-founder of konnect better, bringing a philosophical presence and a unique strategic lens to the mission of strengthening relationships. A thought leader, collaborator, and idea developer, he is deeply committed to finding the best ways to help individuals live more fulfilling lives. Bob balances big picture vision with hands-on practice, ensuring that our tools are both meaningful and actionable. At his core, he’s committed to creating ideas that can inspire real change and deeper connections.',
      image: '/images/bob_gould.png',
      social: {
        linkedin: 'https://www.linkedin.com/in/robert-gould-6aba0214/',
      },
    },
    {
      id: 3,
      name: 'Jolene Watkin',
      role: 'Co-Founder and Associate',
      bio: 'Jolene Watkin spearheads corporate development and daily operations at konnect better, driving innovation and creative solutions to help people cultivate stronger relationships. With a background in business management, she combines strategic insight with a passion for human connection to best support the mission.',
      image: '/images/jolene_watkin.png',
      social: {
        linkedin: 'https://www.linkedin.com/in/jolenewatkin/',
      },
    },
    {
      id: 5,
      name: 'Sylvia Solit',
      role: 'Family Governance Partner',
      bio: 'Sylvia Solit is a dedicated subject matter partner at konnect better, where she leads thoughtful retreats, workshops, and coaching programs designed to help individuals and teams build more meaningful relationships. With years of experience guiding personal and professional growth, Sylvia is passionate about helping others align their values, improve communication, and create lasting, positive change. Her approach is rooted in empathy, authenticity, and a belief in the transformative power of relationships in all areas of life.',
      image: '/images/sylvia_solit.png',
      social: {
        linkedin: 'https://www.linkedin.com/in/sylviasolit/',
      },
    },
  ];

  return (
    <section id="team" className="section bg-surface dark:bg-panel/95">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16">
          {/* Left Section: Title and Subtitle */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-4 lg:sticky lg:top-24 lg:self-start"
          >
            <div className="lg:pr-8">
              <h2 className="text-3xl md:text-4xl font-bold text-primary dark:text-theme-primary mb-4">
                meet our team
              </h2>
              <div className="w-24 h-1 bg-secondary mb-6"></div>
              <p className="text-lg text-theme-secondary">
                We're a diverse team of thought leaders, innovators, and
                relationship specialists, passionate about improving mental
                well-being through innovation.
              </p>
            </div>
          </motion.div>

          {/* Right Section: Team Members */}
          <div className="lg:col-span-8">
            {teamMembers.map((member, index) => (
              <motion.div
                key={member.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <TeamMemberItem member={member} />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
